import { render, staticRenderFns } from "./in-text-area.vue?vue&type=template&id=c069dce6"
import script from "./in-text-area.vue?vue&type=script&lang=js"
export * from "./in-text-area.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports